(function() {
    jQuery(document).ready(function($) {
        $(document).on('submit', 'form[data-backdrop-after]', function(e) {
            var {
                backdropAfter,
                backdropText
            } = $(this).data();

            showLoadingBackdrop(backdropAfter, backdropText);
        });

        $(document).on('click', 'a[data-backdrop-after]', function(e) {
            var {
                backdropAfter,
                backdropText
            } = $(this).data();

            showLoadingBackdrop(backdropAfter, backdropText);
        });

        function showLoadingBackdrop(delayInMs, text) {
            var id = 'backdrop-' + Math.floor(Math.random() * 1000000);

            var $backdrop = $(`
                <div id="${id}" class="modal fade" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
                        <div class="modal-content">
                            <div class="modal-body text-center">
                                <img src="/images/cm-logo-loading.gif" style="width: 6.375rem;"/>
                                <p class="mt-3">${text}</p>
                            </div>
                        </div>
                    </div>
                </div>
            `);

            setTimeout(function() {
                $backdrop.modal('show');
            }, delayInMs);
        }
    });
})();
